"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchUserProfileIfNeeded = fetchUserProfileIfNeeded;
exports.isAppCenterEnabledCheck = isAppCenterEnabledCheck;
exports.default = userProfile;
exports.getOfferingsEnabled = exports.APPCENTER_ENABLED_CHECK_FAILED = exports.APPCENTER_ENABLED_CHECK_PASSED = exports.USER_PROFILE_FETCH_FAILED = exports.USER_PROFILE_FETCHED = exports.USER_PROFILE_FETCHING = void 0;

var _merge2 = _interopRequireDefault(require("lodash/merge"));

var _config = _interopRequireDefault(require("../config"));

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var USER_PROFILE_FETCHING = '@@userProfileModule/USER_PROFILE_FETCHING';
exports.USER_PROFILE_FETCHING = USER_PROFILE_FETCHING;
var USER_PROFILE_FETCHED = '@@userProfileModule/USER_PROFILE_FETCHED';
exports.USER_PROFILE_FETCHED = USER_PROFILE_FETCHED;
var USER_PROFILE_FETCH_FAILED = '@@userProfileModule/USER_PROFILE_FETCH_FAILED';
exports.USER_PROFILE_FETCH_FAILED = USER_PROFILE_FETCH_FAILED;
var APPCENTER_ENABLED_CHECK_PASSED = '@@userProfileModule/IS_APPCENTER_ENABLED_CHECK_PASSED';
exports.APPCENTER_ENABLED_CHECK_PASSED = APPCENTER_ENABLED_CHECK_PASSED;
var APPCENTER_ENABLED_CHECK_FAILED = '@@userProfileModule/IS_APPCENTER_ENABLED_CHECK_FAILED';
exports.APPCENTER_ENABLED_CHECK_FAILED = APPCENTER_ENABLED_CHECK_FAILED;
var APIEndpoint;
var CTEEndpoint = _config.default.CTEUrl;

if ((0, _utils.canUseDOM)()) {
  APIEndpoint = "".concat(_config.default.appcenterAPIBase.client, "/api/userprofile");
} else {
  APIEndpoint = "".concat(_config.default.appcenterAPIBase.server, "/api/userprofile");
}

var getOfferingsEnabled = function getOfferingsEnabled(profile) {
  var offeringsEnabled = [];

  if (profile.IsTripLinkUser) {
    offeringsEnabled.push('TRIPLINK');
  }

  if (profile.IsTravelUser) {
    offeringsEnabled.push('TRVSTD', 'TRVPRO');
  }

  if (profile.IsTravelUser && (profile.TravelOffering === 'PROFESSIONAL' || profile.TravelOffering === 'STANDARD')) {
    offeringsEnabled.push('TRQPRO');
  }

  if (profile.IsExpenseUser && (profile.ExpenseOffering === 'CTE' || profile.ExpenseOffering === 'HONG_KONG')) {
    offeringsEnabled.push('EXPSTD', 'INVSTD', 'INVPRO');
  }

  if (profile.IsExpenseUser && profile.ExpenseOffering === 'CTE') {
    offeringsEnabled.push('EXPPRO');
  }

  return offeringsEnabled;
};

exports.getOfferingsEnabled = getOfferingsEnabled;

function fetchUserProfileIfNeeded() {
  return function _callee(dispatch, getState) {
    var _getState, _getState$JWT, _getState$JWT$token, token, userProfile, options, url, response, user, offeringsEnabled;

    return regeneratorRuntime.async(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _getState = getState(), _getState$JWT = _getState.JWT;
            _getState$JWT = _getState$JWT === void 0 ? {} : _getState$JWT;
            _getState$JWT$token = _getState$JWT.token, token = _getState$JWT$token === void 0 ? '' : _getState$JWT$token, userProfile = _getState.userProfile;

            if (!(token && userProfile && !userProfile.offeringsEnabled)) {
              _context.next = 24;
              break;
            }

            options = {
              method: 'GET',
              headers: {
                Authorization: "Bearer ".concat(token)
              }
            };
            url = "".concat(APIEndpoint);
            _context.prev = 6;
            _context.next = 9;
            return regeneratorRuntime.awrap(fetch(url, options));

          case 9:
            response = _context.sent;
            _context.next = 12;
            return regeneratorRuntime.awrap(response.json());

          case 12:
            user = _context.sent;

            if (getState().userProfile.offeringsEnabled) {
              _context.next = 17;
              break;
            }

            dispatch({
              type: USER_PROFILE_FETCHING
            });
            offeringsEnabled = getOfferingsEnabled(user);
            return _context.abrupt("return", Promise.resolve(dispatch({
              type: USER_PROFILE_FETCHED,
              offeringsEnabled: offeringsEnabled,
              user: user
            })));

          case 17:
            _context.next = 22;
            break;

          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](6);
            dispatch({
              type: USER_PROFILE_FETCH_FAILED,
              error: _context.t0
            });

          case 22:
            _context.next = 25;
            break;

          case 24:
            return _context.abrupt("return", Promise.resolve());

          case 25:
          case "end":
            return _context.stop();
        }
      }
    }, null, null, [[6, 19]]);
  };
}

function isAppCenterEnabledCheck() {
  return function _callee2(dispatch, getState) {
    var _getState2, profile;

    return regeneratorRuntime.async(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return regeneratorRuntime.awrap(dispatch(fetchUserProfileIfNeeded()));

          case 2:
            _getState2 = getState(), profile = _getState2.userProfile.profile;

            if (profile && !profile.IsAppCenterEnabled) {
              dispatch({
                type: APPCENTER_ENABLED_CHECK_FAILED
              });
              window.location = "".concat(CTEEndpoint, "/errors/securitybreach.asp?nolog=1");
            } else {
              dispatch({
                type: APPCENTER_ENABLED_CHECK_PASSED
              });
            }

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    });
  };
}

var initialState = {};

function userProfile() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case USER_PROFILE_FETCHED:
      return _objectSpread({}, state, {
        offeringsEnabled: action.offeringsEnabled,
        profile: action.user
      });

    case USER_PROFILE_FETCH_FAILED:
      return _objectSpread({}, state, {
        error: action.error
      });

    case 'dev/user':
      return (0, _merge2.default)({}, state, action.newValue);

    default:
      return state;
  }
}


//////////////////
// WEBPACK FOOTER
// ./lib/userProfile/userProfileModule.js
// module id = 24
// module chunks = 0